const uploadcontract = {
  path: 'uploadcontract',
  component: resolve => require(['../../../pages/uploadContract'], resolve)
}

export default uploadcontract
